import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

import Typography from "@mui/material/Typography";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import TimeTable from "../time-table/TimeTable";
import { toTimeRows } from "../time-table/timeTableSlice";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { SerializedError } from "../../util/types";
import Metadata from "../metadata/Metadata";
import MDViewer from "../markdown/Markdown";
import {
    Ticket,
    TicketEditRequest,
    selectTicket,
    selectChildrenItems,
    toEditRequest,
} from "./ticketSlice";
import {
    useTicketViewQuery,
    useEditMutation,
    TicketResponse,
} from "../../api/ticket";
import TicketEditDisplay from "./TicketEditDisplay";
import TicketPaneViewer from "./TicketPaneViewer";
import { ToolBar } from "./RightToolBar";
import EditToolBar from "./EditToolBar";

const vcontentStyle = {
    height: "100%",
    width: "100%",
    margin: 0,
    display: "flex",
    //backgroundColor: 'pink',
};
const contentStyle = {
    height: "100%",
    width: "100%",
    margin: 0,
    //overflow: 'auto',
    display: "flex",
    //backgroundColor: 'grey',
};
const colOneStyle = {
    height: "100%",
    flexGrow: 4,
    width: "50%",
    //backgroundColor: '#eeeeee',
    //overflow: 'auto',
};
const colTwoStyle = {
    height: "100%",
    flexGrow: 4,
    //backgroundColor: 'green',
    width: "50%",
    //overflow: 'auto',
};
const viewStyle = {
    height: `calc(100% - 44px)`,
    overflow: "auto",
    padding: 0,
    width: "100%",
    //height: '100%r',
    //backgroundColor: 'purple',
};

export function TicketEdit() {
    const navigate = useNavigate();
    let { id } = useParams();
    const idv = id ? id : null;
    const idStr = id ? id : "";
    let [ter, setTer] = React.useState<TicketEditRequest | null>(null);
    const [updateTicket, { isLoading: isUpdating }] = useEditMutation();
    const onSave = () => {
        if (ter) {
            updateTicket(ter)
                .unwrap()
                .then((fullfilled) => {
                    if (fullfilled && fullfilled.ticket) {
                        navigate(
                            "/ticket/view/" + fullfilled.ticket.metadata.id,
                        );
                    }
                });
        }
        console.log("2024101608254", ter);
    };
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useTicketViewQuery(idStr, { refetchOnMountOrArgChange: true });
    return (
        <Box sx={vcontentStyle}>
            <Box sx={contentStyle}>
                <Box sx={colOneStyle}>
                    <Box sx={viewStyle}>
                        <Grid container spacing={0} sx={vcontentStyle}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <EditToolBar
                                    id={idv}
                                    onChange={onSave}
                                    parent_id={"3"}
                                />
                                <Box sx={{ height: 45 }}></Box>
                                <TicketViewerLeft
                                    id={idv}
                                    data={data}
                                    isLoading={isLoading}
                                    isFetching={isFetching}
                                    isSuccess={isSuccess}
                                    isError={isError}
                                    error={error}
                                    onChange={(ter: TicketEditRequest) => {
                                        setTer(ter);
                                        console.log("202411100920", ter);
                                    }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <ToolBar />
                                <Box sx={{ height: 45 }}>ktype</Box>
                                <TicketViewerRight
                                    id={idv}
                                    data={data}
                                    isLoading={isLoading}
                                    isFetching={isFetching}
                                    isSuccess={isSuccess}
                                    isError={isError}
                                    error={error}
                                    onChange={(ter: TicketEditRequest) => {}}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
    /*
     * 2025-09-01T07h34: replacing to try with grid, responsive for mobile
	return (
		<Box sx={vcontentStyle}>
			<Box sx={contentStyle}>
				<Box sx={colOneStyle}>
					<EditToolBar id={idv} onChange={onSave} parent_id={"3"}/>
					<Box sx={{height: 45}}>
					</Box>
					<Box sx={viewStyle}>
						<TicketViewerLeft
							id={idv}
							data={data}
							isLoading={isLoading}
							isFetching={isFetching}
							isSuccess={isSuccess}
							isError={isError}
							error={error}
							onChange={(ter: TicketEditRequest) => {
								setTer(ter);
								console.log("202411100920", ter);
							}}
						/>
					</Box>
				</Box>
				<Box sx={colTwoStyle}>
					<ToolBar />
					<Box sx={{height: 45}}>
						ktype
					</Box>
					<Box sx={viewStyle}>
						<TicketViewerRight
							id={idv}
							data={data}
							isLoading={isLoading}
							isFetching={isFetching}
							isSuccess={isSuccess}
							isError={isError}
							error={error}
							onChange={(ter: TicketEditRequest) => {}}
						/>
						<Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
    // */
}
interface QueryProps {
    id: string | null;
    data: TicketResponse;
    isLoading: boolean;
    isFetching: boolean;
    isSuccess: boolean;
    isError: boolean;
    error: FetchBaseQueryError | SerializedError | undefined;
    onChange: (ter: TicketEditRequest) => void;
}

export function TicketViewerLeft({
    id,
    data,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    onChange,
}: QueryProps) {
    //const ticket = useAppSelector(selectTicket(id ? id : ""));
    let content: React.ReactNode;

    if (isLoading) {
        content = <TicketViewerLoading />;
    } else if (isFetching) {
        content = <TicketViewerFetching />;
    } else if (isSuccess) {
        content = <TicketViewerSuccess data={data} onChange={onChange} />;
    } else if (isError) {
        content = <TicketViewerError error={error} />;
    }
    return <Box>{content}</Box>;
}

export function TicketViewerRight({
    id,
    data,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
}: QueryProps) {
    const tItems = useAppSelector(selectChildrenItems(id));
    const tRows = toTimeRows(tItems);
    return (
        <Box>
            <TimeTable
                data={tRows}
                refDate={new Date()}
                linkTo={"context"}
                titleLink={(id: string) => "/ticket/view/" + id}
            />
        </Box>
    );
}

export function TicketViewerLoading() {
    return <Box>Loading</Box>;
}

export function TicketViewerFetching() {
    return <Box>Fetching</Box>;
}

export function TicketViewerError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <Box>Error</Box>;
}

interface TESProps {
    data: TicketResponse;
    onChange: (ter: TicketEditRequest) => void;
}

export function TicketViewerSuccess({ data, onChange }: TESProps) {
    const ticket = data.ticket;
    return (
        <TicketEditDisplay
            ticket={toEditRequest(ticket)}
            onTERChange={(ter: TicketEditRequest) => {
                console.log("202411052356", ter);
                onChange(ter);
            }}
        />
    );
    /*
	   if (ticket) {
	   return (
	   <TicketEditDisplay
	   ticket={toEditRequest(ticket)}
	   onTERChange={(ter: TicketEditRequest) => {
	   console.log("202411052356", ter);
	   onChange(ter);
	   }}
	   />
	   );
	   } else {
	   return (
	   <Box> Nothing </Box>
	   )
	   }
	//*/
}
